import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@/components/ui/table";

const CustomerDataTable = ({
  serviceType,
  order,
}: {
  serviceType: ServiceType;
  order: OrderState;
}) => {
  const { t } = useTranslation();

  return (
    <Table className="border">
      <TableBody>
        <TableRow className="divide-x">
          <TableHead className="h-10 bg-muted text-foreground">
            {t("labels.full-name")}
          </TableHead>
          <TableCell className="py-2">{order.name}</TableCell>
        </TableRow>
        <TableRow className="divide-x">
          <TableHead className="h-10 bg-muted text-foreground">
            {t("labels.nric-number")}
          </TableHead>
          <TableCell className="py-2">{order.nricNumber}</TableCell>
        </TableRow>
        <TableRow className="divide-x">
          <TableHead className="h-10 bg-muted text-foreground">
            {t("labels.email")}
          </TableHead>
          <TableCell className="py-2">{order.email}</TableCell>
        </TableRow>
        {serviceType === "tourist" && (
          <TableRow className="divide-x">
            <TableHead className="h-10 bg-muted text-foreground">
              {t("labels.date-of-arrival")}
            </TableHead>
            <TableCell className="py-2">
              {order.dateOfArrival &&
                format(order.dateOfArrival, "dd MMMM yyyy")}
            </TableCell>
          </TableRow>
        )}
        {serviceType !== "tourist" && (
          <>
            <TableRow className="divide-x">
              <TableHead className="h-10 bg-muted text-foreground">
                {t("labels.mobile-number")}
              </TableHead>
              <TableCell className="py-2">{order.mobileNumber}</TableCell>
            </TableRow>
            {order.homeNumber && (
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.land-line-number")}
                </TableHead>
                <TableCell className="py-2">{order.homeNumber}</TableCell>
              </TableRow>
            )}
            {order.officeNumber && (
              <TableRow className="divide-x">
                <TableHead className="h-10 bg-muted text-foreground">
                  {t("labels.office-number")}
                </TableHead>
                <TableCell className="py-2">{order.officeNumber}</TableCell>
              </TableRow>
            )}
            <TableRow className="divide-x">
              <TableHead className="h-10 bg-muted text-foreground">
                {t("labels.date-of-birth")}
              </TableHead>
              <TableCell className="py-2">
                {order.dateOfBirth && format(order.dateOfBirth, "dd MMMM yyyy")}
              </TableCell>
            </TableRow>
            <TableRow className="divide-x">
              <TableHead className="h-10 bg-muted text-foreground">
                {t("labels.citizenship")}
              </TableHead>
              <TableCell className="py-2">{order.citizenship}</TableCell>
            </TableRow>
          </>
        )}
      </TableBody>
    </Table>
  );
};

const EasiRechargeCustomerDataTable = ({
  state,
}: {
  state: EasiRechargeState;
}) => {
  const { t } = useTranslation();

  return (
    <Table className="border">
      <TableBody>
        <TableRow className="divide-x">
          <TableHead className="h-10 bg-muted text-foreground">
            {t("labels.mobile-number")}
          </TableHead>
          <TableCell className="py-2">{state.mobileNumber}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export { CustomerDataTable, EasiRechargeCustomerDataTable };
